<template>
  <el-dialog :close-on-click-modal="false"
             :title="titleDialog"
             :visible="showDialog"
             append-to-body
             @close="close"
             @open="create">
    <form autocomplete="off"
          @submit.prevent="submit">
      <div class="form-body">
        <div class="row">
          <div class="col-md-6">
            <div :class="{'has-danger': errors.plate_number}"
                 class="form-group">
              <label class="control-label">Nro. de Placa <span class="text-danger">*</span>
                <el-tooltip placement="top">
                  <div slot="content">
                    La placa del vehículo no puede contener guiones ni minúsculas.<br>
                    La placa no puede ser de motos
                  </div>
                  <i class="fa fa-info-circle"></i>
                </el-tooltip>
              </label>
              <el-input v-model="form.plate_number"
                        dusk="name"></el-input>
              <small v-if="errors.plate_number"
                     class="form-control-feedback"
                     v-text="errors.plate_number[0]"></small>
            </div>
          </div>
          <div class="col-md-6">
            <div :class="{'has-danger': errors.model}"
                 class="form-group">
              <label class="control-label">Modelo</label>
              <el-input v-model="form.model"></el-input>
              <small v-if="errors.model"
                     class="form-control-feedback"
                     v-text="errors.model[0]"></small>
            </div>
          </div>
          <div class="col-md-6">
            <div :class="{'has-danger': errors.brand}"
                 class="form-group">
              <label class="control-label">Marca</label>
              <el-input v-model="form.brand"></el-input>
              <small v-if="errors.brand"
                     class="form-control-feedback"
                     v-text="errors.brand[0]"></small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group" style="margin-top: 32px;">
              <el-switch v-model="form.is_default"
                         active-text="Predeterminado"
                         inactive-text=""></el-switch>
            </div>
          </div>
          <div class="col-md-6">
            <div :class="{'has-danger': errors.tuc}"
                 class="form-group">
              <label class="control-label">Certificado de habilitación vehicular o TUC / TUCE
                <el-tooltip content="Tarjeta Única de Circulación Electrónica (TUC o TUCE)" placement="top">
                  <i class="fa fa-info-circle"></i>
                </el-tooltip>
              </label>
              <el-input v-model="form.tuc"></el-input>
              <small v-if="errors.tuc"
                     class="invalid-feedback"
                     v-text="errors.tuc[0]"></small>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <el-checkbox label="Datos de la autorización especial para el traslado de la carga"
                         v-model="form.is_special_authorization"></el-checkbox>
          </div>
        </div>

        <template v-if="form.is_special_authorization">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{ 'has-danger': errors.emission_entity }">
                <label class="control-label">Entidad emisora de la autorización <span class="text-danger">*</span></label>
                <el-select v-model="form.emission_entity" placeholder="Seleccione una opción"
                          filterable
                          clearable >
                  <el-option v-for="(item, index) in emission_entities"
                      :key="index"
                      :label="item.description"
                      :value="item.id"></el-option>
                </el-select>
                <small v-if="errors.emission_entity"
                     class="text-danger">{{ errors.emission_entity }}</small>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" :class="{ 'has-danger': errors.authorization_number }">
                <label class="control-label">Número de autorización <span class="text-danger">*</span></label>
                <el-input v-model="form.authorization_number" placeholder="Ingrese el número de autorización"></el-input>
                <small v-if="errors.authorization_number"
                     class="text-danger">{{ errors.authorization_number }}</small>
              </div>
            </div>
          </div>
        </template>

      </div>
      <div class="form-actions text-right mt-4">
        <el-button @click.prevent="close()">Cancelar</el-button>
        <el-button :loading="loading_submit"
                   native-type="submit"
                   type="primary">Guardar
        </el-button>
      </div>
    </form>
  </el-dialog>
</template>

<script>

export default {
  name: 'DispatchTransportForm',
  props: ['showDialog', 'recordId', 'external', 'entities'],
  data() {
    return {
      loading_submit: false,
      titleDialog: null,
      resource: 'transports',
      errors: {},
      form: {},
      emission_entities: [],
    }
  },
  created() {
    this.initForm()
    if (this.entities) {
      this.assignDataEntities(this.entities);
    }
  },
  methods: {
    initForm() {
      this.errors = {
        plate_number: null,
        model: null,
        brand: null,
        tuc: null,
        emission_entity: null,
        authorization_number: null,
      }
      this.form = {
        id: null,
        plate_number: null,
        model: null,
        brand: null,
        is_default: false,
        is_active: true,

        is_special_authorization: false,
        emission_entity: null,
        authorization_number: null,
      }
    },
    async create() {
      this.initForm();
      this.titleDialog = (this.recordId) ? 'Editar Vehículo' : 'Nuevo Vehículo'
      if (this.recordId) {
        await this.$http.get(`/${this.resource}/record/${this.recordId}`)
            .then(response => {
              this.form = response.data.data
            })
      }
    },
    async submit() {
      if(this.form.tuc){
        this.form.tuc = this.form.tuc.toUpperCase();
        if(this.form.tuc.length<10 || this.form.tuc.length>15){
          return this.$message.error('Certificado de habilitación vehicular debe ser alfanumérico de 10 a 15  caracteres')
        }
      }

      const result = this.validateEntity()
      if (result) return
    
      this.loading_submit = true
      await this.$http.post(`/${this.resource}`, this.form)
          .then(response => {
            if (response.data.success) {
              this.$message.success(response.data.message)
              this.$emit('success', response.data.id)
              this.close()
            } else {
              this.$message.error(response.data.message)
            }
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data
            } else {
              console.log(error)
            }
          })
          .then(() => {
            this.loading_submit = false
          })
    },
    close() {
      this.$emit('update:showDialog', false)
    },

    assignDataEntities(val) {
      this.emission_entities = val.map(row => {
        return {
          id: row.code,
          description: `${row.abbreviation} - ${row.name}`
        }
      })
    },

    validateEntity() {
      let hasErrors = false
      if (this.form.is_special_authorization) {
        if (!this.form.emission_entity) {
          this.errors.emission_entity = 'Seleccione un entidad emisora'
          hasErrors = true
        }
        if (!this.form.authorization_number) {
          this.errors.authorization_number = 'Ingrese el número de autorización'
          hasErrors = true
        }
      }
      return hasErrors
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/dispatches/transports/form.vue